// extracted by mini-css-extract-plugin
export default {"root":"AddCredentialCard_root__1ug3y","content":"AddCredentialCard_content__3h6tO"};